import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { isEmpty, isEqual, noop } from 'lodash';
import { VideoCard } from './card/card';
import { VIDEO_CARD_TYPES, VIDEO_CARDS_POSITIONS, } from '@wix/wix-vod-constants/video-cards';
import { ANCHOR_POINTS } from '@wix/wix-vod-cards';
const anchorPointsMap = {
    [VIDEO_CARDS_POSITIONS.BOTTOM_LEFT]: ANCHOR_POINTS.BOTTOM_LEFT,
    [VIDEO_CARDS_POSITIONS.BOTTOM_RIGHT]: ANCHOR_POINTS.BOTTOM_RIGHT,
};
const getPlayerCardData = ({ cardData, index, contentNode, }) => {
    const { clientId: id, from, to } = cardData;
    const order = index;
    const hasDynamicContent = cardData.type === VIDEO_CARD_TYPES.SOCIAL;
    return { id, from, to, order, contentNode, hasDynamicContent };
};
class VideoCardWrap extends React.Component {
    constructor(props) {
        super(props);
        this.contentNode = document.createElement('div');
        this.setCardAccessible = (isAccessible) => {
            this.setState({ isAccessible });
        };
        const { player } = this.props;
        this.state = { isAccessible: false };
        player.onCardHidden(() => this.setCardAccessible(false));
        player.onCardShown(() => this.setCardAccessible(true));
    }
    getPlayerCardData(props) {
        const { cardData, index } = props;
        const { contentNode } = this;
        return getPlayerCardData({ contentNode, cardData, index });
    }
    componentDidMount() {
        const { player } = this.props;
        player
            .addCard(this.getPlayerCardData(this.props))
            .then(() => this.updateActiveCard());
    }
    componentDidUpdate(oldProps) {
        const newCardData = this.getPlayerCardData(this.props);
        const oldCardData = this.getPlayerCardData(oldProps);
        if (!isEqual(oldCardData, newCardData)) {
            const { player } = this.props;
            player.updateCards([newCardData]).then(() => this.updateActiveCard());
        }
    }
    updateActiveCard() {
        const { player, isActive, cardData } = this.props;
        if (!isActive) {
            return;
        }
        player.setActiveCard(cardData.clientId);
    }
    componentWillUnmount() {
        const { player, cardData } = this.props;
        if (player && player.removeCard) {
            player.removeCard(cardData.clientId);
        }
    }
    render() {
        const { onCardClick, labels, cardData } = this.props;
        const { isAccessible } = this.state;
        return ReactDOM.createPortal(React.createElement(VideoCard, { labels: labels, isAccessible: isAccessible, cardData: cardData, onCardClick: onCardClick }), this.contentNode);
    }
}
const getCardsAnchorPoint = (cardsData) => {
    // all cards contain position value, and it's the same for all cards
    const [sampleCard] = cardsData;
    return anchorPointsMap[sampleCard.position];
};
class VideoCards extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.cardsConfig = {
            anchorPoint: ANCHOR_POINTS.BOTTOM_LEFT,
        };
    }
    componentDidUpdate() {
        this.updateCardsConfig();
    }
    updateCardsConfig() {
        const { player, cardsData } = this.props;
        if (!player || isEmpty(player) || isEmpty(cardsData)) {
            return;
        }
        const newAnchorPoint = getCardsAnchorPoint(cardsData);
        if (newAnchorPoint !== this.cardsConfig.anchorPoint) {
            player.setAnchorPoint(newAnchorPoint);
            this.cardsConfig.anchorPoint = newAnchorPoint;
        }
        // TODO update cards orientation
    }
    render() {
        const { player, cardsData, onCardClick, labels, activeVideoCard } = this.props;
        if (!player || isEmpty(player)) {
            return null;
        }
        return (React.createElement(React.Fragment, null, cardsData.map((cardData, index) => (React.createElement(VideoCardWrap, { key: cardData.clientId, player: player, labels: labels, onCardClick: onCardClick, cardData: cardData, index: index, isActive: !!activeVideoCard &&
                cardData.clientId === activeVideoCard.clientId })))));
    }
}
VideoCards.propTypes = {
    player: PropTypes.object,
    cardsData: PropTypes.array,
    onCardClick: PropTypes.func,
    activeVideoCard: PropTypes.object,
    labels: PropTypes.object,
};
VideoCards.defaultProps = {
    onCardClick: noop,
};
export { VideoCards, VIDEO_CARD_TYPES, VIDEO_CARDS_POSITIONS, };
//# sourceMappingURL=video-cards.js.map